import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const confirmModal = createAction(ACTION.CONFIRM, (name, message, data = {}) => ({name, message, data}));
export const accept = createAction(ACTION.ACCEPT, (name, data = {}) => ({name, data}));
export const cancel = createAction(ACTION.CANCEL, (name, data = {}) => ({name, data}));
export const alert = createAction(ACTION.ALERT, (name, message, data = {}) => ({name, message, data}));
export const close = createAction(ACTION.CLOSE, (name, data = {}) => ({name, data}));
